import { makeStyles } from '@material-ui/styles';

const styles = {
  rtmWrapper: {
    display: 'inline-block',
    verticalAlign: 'top',
  },
};

export default makeStyles(styles, { name: 'UTTO-Components-DialogStyles' });
